import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { CustomerModel } from '@df/session/api/customer.model';
import { TradeStoreService } from './trade-store.service';
declare module '@angular/router' {
    interface ActivatedRouteSnapshot {
        preventRedirect?: boolean;
    }
}
@Injectable({
    providedIn: 'root'
})
export class IsTradeStoreGuard implements CanActivate {
    constructor(private tradeStoreService: TradeStoreService, private router: Router, private customerModel: CustomerModel) { }
    canActivate(): Promise<boolean> {
        return new Promise((resolve, reject) => {
            this.customerModel
                .load()
                .then(() => {
                resolve(this.tradeStoreService.hasTradeMenu());
            })
                .catch(reject);
        });
    }
    onError(): void {
        this.router.navigateByUrl('/');
    }
}
